import {
  AddScheduleActionTypes,
  ADD_SCHEDULE_FAIL,
  ADD_SCHEDULE_LOADING,
  ADD_SCHEDULE_SUCCESS,
  AddScheduleState,
  ADD_SCHEDULE_UPDATE_API_MSG,
  ADD_SCHEDULE_UPDATE_API_RES,
} from "./ActionTypes";
import { AddScheduleRes } from "./Model";

const initialStateGetPosts: AddScheduleState = {
  loading: false,
  addScheduleRes: {} as AddScheduleRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const addScheduleReducer = (
  state = initialStateGetPosts,
  action: AddScheduleActionTypes
): AddScheduleState => {
  switch (action.type) {
    case ADD_SCHEDULE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_SCHEDULE_SUCCESS:
      return {
        ...state,
        addScheduleRes: action.payload,
        successMsg: action.successMsg,
      };
    case ADD_SCHEDULE_FAIL:
      return {
        ...state,
        addScheduleRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_SCHEDULE_UPDATE_API_MSG:
      return {
        ...state,
        addScheduleRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_SCHEDULE_UPDATE_API_RES:
      return {
        ...state,
        addScheduleRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
